import { MidTermPlan } from '@/components/pages/Ir/Library/MidTermPlan'

export default MidTermPlan
